////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { last } from 'lodash'
///////COMPONENTS///////
import FactoryPageSelected from './FactoryPageSelected'

/////////STYLED/////////
const PagingListWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(5, max-content);
	grid-column-gap: 5px;
	justify-content: center;
	align-items: center;
`
const NumberPageLabel = styled.label`
	display: flex;
	height: 32px;
	width: 32px;
	border-radius: 50%;
	justify-content: center;
	align-items: center;
	background-color: ${(props) => (props.isActive ? '#E5E5E5' : 'transparent')};
	cursor: pointer;
	color: ${(props) => props.theme.colors.tabText};
`
const NumberPageInput = styled.input`
	display: none;
	height: 32px;
	width: 32px;
	border-radius: 50%;
	justify-content: center;
	align-items: center;
	background-color: #e5e5e5;
`
const ToContinue = styled.p`
	display: flex;P
	margin: 0 0;
	padding: 0 0;
`
/////////STYLED/////////

const PagingList = ({ options, register, setValue, getValues, totalPage, submitHandler }) => {
	const lastOption = last(options).toString()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSwapPage = (opt) => {
		setValue('goToPage', opt.toString())
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<PagingListWrapper>
			<NumberPageLabel isActive={getValues('goToPage') === '0'}>
				<NumberPageInput
					type="radio"
					name="tmpGoTo"
					value="0"
					ref={register}
					onClick={() => {
						let submitAsked = false
						if (getValues('tmpGoTo') !== getValues('goToPage')) submitAsked = true
						handleSwapPage('0')
						if (submitAsked) submitHandler(getValues())
					}}
				/>
				{options[0]}
			</NumberPageLabel>

			{getValues('goToPage') > 1 && totalPage >= 4 && <ToContinue>...</ToContinue>}
			{totalPage >= 2 && (
				<FactoryPageSelected options={options} register={register} handleSwapPage={handleSwapPage} pageValue={getValues('goToPage')} />
			)}

			{getValues('goToPage') < last(options) - 2 && totalPage >= 4 && <ToContinue>...</ToContinue>}

			{totalPage >= 3 && (
				<NumberPageLabel isActive={getValues('goToPage') === (last(options) - 1).toString()}>
					<NumberPageInput
						type="radio"
						name="tmpGoTo"
						value={lastOption}
						ref={register}
						onClick={() => handleSwapPage(options.length - 1)}
					/>
					{last(options)}
				</NumberPageLabel>
			)}
		</PagingListWrapper>
	)
}

PagingList.propTypes = {}

PagingList.defaultPropTypes = {}

export default PagingList
